<ng-container *ngrxLet="entity | get : props.path as claimsValue">
  <ng-container *ngIf="!props?.predicate(claimsValue); else hasClaims"
    >-</ng-container
  >
  <ng-template #hasClaims>
    <lui-avatar
      color="orange"
      [size]="24"
      matTooltip="New claims notified"
      i18n-matTooltip
    >
      <mat-icon svgIcon="enquiry_thin"></mat-icon>
    </lui-avatar>
  </ng-template>
</ng-container>
